/**
 * Component that enables runtime test-id injection
 * Place this component at the top level of your app or router
 */

import React from "react";
import { useTestIdInjection, TestIdInjectionConfig } from "../../utils/testIdInjection";

export interface TestIdInjectorProps {
  /**
   * Configuration options for test-id injection
   */
  config?: TestIdInjectionConfig;
}

/**
 * TestIdInjector component
 * This component initializes the automatic test-id injection system
 *
 * Usage:
 * 1. Place this component in your Router or Layout component
 * 2. Enable via environment variable: REACT_APP_AUTO_TEST_ID=true
 * 3. Or pass enabled prop: <TestIdInjector config={{ enabled: true }} />
 *
 * Example:
 * ```tsx
 * import { TestIdInjector } from "./components/TestIdInjector/TestIdInjector";
 *
 * const App = () => {
 *   return (
 *     <Router>
 *       <TestIdInjector config={{ enabled: true }} />
 *       <Layout>
 *         // Your routes
 *       </Layout>
 *     </Router>
 *   );
 * };
 * ```
 */
export const TestIdInjector: React.FC<TestIdInjectorProps> = ({ config }) => {
  useTestIdInjection(config);

  // This component doesn't render anything
  return null;
};

export default TestIdInjector;
